import * as React from 'react';

export const LazyGoalNOKExclusion = React.lazy(() => import('./component'));
